// extracted by mini-css-extract-plugin
export default {"card":"PreviewCard_card__a2dmW"};